import { schema } from 'normalizr';

const organisation = new schema.Entity('organisations', {}, { idAttribute: 'id' });
const organisationsSchema = [organisation];

export default organisationsSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/organisationSchema.js